import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative w-full min-h-screen overflow-hidden bg-gray-950 text-white">

      {/* ─── Background Video ─── */}
 <div className="absolute inset-0 z-0">
  {/* Mobile video */}
    <video autoPlay muted loop playsInline className="block md:hidden w-full h-full object-cover object-[center_25%]">
    <source src="/assest/connection-mb.mp4" type="video/mp4" />
  </video>
  {/* Desktop video */}
  <video autoPlay muted loop playsInline className="hidden md:block w-full h-full object-cover object-[center_15%]">
    <source src="/assest/connection_bg.mp4" type="video/mp4" />
  </video>
  {/* Mobile gradient for text readability */}
  <div className="absolute inset-0 md:hidden bg-gradient-to-b from-black/10  to-black/10" />
</div>

      {/* ─── YouTube Circle Button — Desktop ─── */}
      <motion.div initial={{ opacity:0, scale:0.8 }} animate={{ opacity:1, scale:1 }} transition={{ duration:0.8, delay:0.8, ease:'easeOut' }} className="z-20">
        <div className="hidden md:block absolute right-8 lg:right-16 top-1/2 -translate-y-1/2 z-50">
          <a href="https://www.youtube.com/@VibrantViva" target="_blank" rel="noopener noreferrer" className="relative block w-32 h-32 lg:w-36 lg:h-36 group" aria-label="Play Our Promotional Video" style={{ pointerEvents:'auto' }}>
            <div className="absolute inset-0 animate-spin-slow">
              <svg viewBox="0 0 200 200" className="w-full h-full">
                <defs><path id="circle" d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0" /></defs>
                <text className="text-[18px] lg:text-[20px] fill-blue-400 font-bold uppercase tracking-[0.25em]">
                  <textPath xlinkHref="#circle">Visit Our YouTube Channel </textPath>
                </text>
              </svg>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-blue-500 flex items-center justify-center shadow-2xl shadow-blue-500 group-hover:scale-110 group-hover:bg-blue-500 transition-all duration-300">
                <svg className="w-5 h-5 lg:w-6 lg:h-6 text-white ml-1" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
              </div>
            </div>
            <div className="absolute inset-0 rounded-full">
              <div className="absolute inset-0 rounded-full border-2 border-blue-500 animate-ping" />
              <div className="absolute inset-0 rounded-full border border-blue-500 animate-pulse" />
            </div>
          </a>
        </div>
      </motion.div>

      {/* ─── Content ─── */}
<div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 lg:pl-16 lg:pr-16 lg:flex-row lg:items-center lg:justify-start">
  <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start gap-5 text-center lg:text-left">

    {/* Main Heading */}
    <motion.h1
      initial={{ opacity:0, y:30 }} animate={{ opacity:1, y:0 }}
      transition={{ duration:0.7, delay:0.15, ease:'easeOut' }}
      className="hero-heading text-6xl sm:text-7xl lg:text-8xl font-extrabold leading-tight tracking-tight"
    >
      <span className="text-white">Vibrant</span>
      <span className="text-blue-500">Viva</span>
    </motion.h1>

    {/* Description */}
<motion.p
  initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }}
  transition={{ duration:0.6, delay:0.45, ease:'easeOut' }}
  className="hero-desc text-white/100 text-lg sm:text-xl lg:text-2xl max-w-md leading-relaxed text-center lg:text-left lg:ml-16 lg:mt-0"
>
  Empowering Ethical Entrepreneurship
</motion.p>

    {/* YouTube Circle — Mobile only, centered below heading */}
    <div className="flex justify-center mt-6 md:hidden">
      <a href="https://www.youtube.com/@VibrantViva" target="_blank" rel="noopener noreferrer" className="relative block w-28 h-28 group" aria-label="Play Our Promotional Video">
        <div className="absolute inset-0 animate-spin-slow">
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <defs><path id="circle" d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0" /></defs>
            <text className="text-[15px] fill-blue-400 font-bold uppercase tracking-[0.25em]">
              <textPath xlinkHref="#circle">Visit Our YouTube Channel </textPath>
            </text>
          </svg>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center shadow-2xl shadow-blue-500/50 group-hover:scale-110 group-hover:bg-blue-400 transition-all duration-300">
            <svg className="w-5 h-5 text-white ml-1" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
          </div>
        </div>
        <div className="absolute inset-0 rounded-full">
          <div className="absolute inset-0 rounded-full border-2 border-blue-500/30 animate-ping" />
          <div className="absolute inset-0 rounded-full border border-blue-500/20 animate-pulse" />
        </div>
      </a>
    </div>

  </div>
</div>
      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Outfit:wght@300;400;500;600;700&display=swap');

        section, section *, section *::before, section *::after {
          font-family: 'Outfit', sans-serif;
        }

        .hero-heading {
          font-family: 'Cormorant Garamond', serif !important;
          font-weight: 600 !important;
        }

        .hero-desc {
          font-family: 'Outfit', sans-serif !important;
          font-weight: 300 !important;
        }

        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 12s linear infinite;
        }
      `}} />
    </section>
  );
};

export default Hero;